import React, { useCallback, useState, useContext, createContext } from 'react';

const defaultValue = {
  content: null,
  setFooter: () => {},
};

export const FooterContext = createContext(defaultValue);

export const FooterContextProvider = (props) => {
  const [state, setState] = useState(defaultValue);

  const handleFooterSetState = useCallback((props) => {
    setState((prevState) => {
      const newProps = (typeof props === 'function') ? props(prevState) : props;
      const {
        content,
      } = newProps;

      return {
        content,
      };
    });
  }, []);

  const context = {
    content: state.content,
    setFooter: handleFooterSetState,
  };

  return (
    <FooterContext.Provider value={context}>
      {props.children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => useContext(FooterContext);
